import type { StateCreator } from 'zustand'

import type { AllSlices } from '../types'
import type { ComponentsSlice } from '../types/components'

export const createComponentsSlice: StateCreator<
  AllSlices,
  [],
  [],
  ComponentsSlice
> = set => ({
  account: '',
  gets: { username: '', display_platform: '' },
  others: [],
  banners: { homepage: [], casino: [], referral: [], registration: [] },
  // Default to loading: the components/banners fetch fires on mount, so the
  // banner skeleton should reserve its (aspect-ratio) space from the first
  // paint. Starting at `false` rendered an empty banner slot that the skeleton
  // then expanded, shoving the whole games grid down — the dominant mobile CLS.
  isLoading: true,
  setIsLoading: value => {
    set(state => ({
      components: { ...state.components, isLoading: value },
    }))
  },
  setComponents: data => {
    set(state => ({
      components: {
        ...state.components,
        ...data,
      },
    }))
  },
})
